import { useSelector } from "react-redux";
import styles from './DropdownFilter.module.css';

export default function DropdownFilter({ handleSelect, seriesId, label, value, column }) {
  // get data from Redux state
  const data = useSelector((state) => state.visualizer.productDataBySeries[seriesId]);

  // ensure unique dropdown options
  const uniqueOptions = [...new Set(data.map(d => d[column]))];


  const dropdownOptions = uniqueOptions.map((option, index) => (
    <option key={index} value={option} defaultValue={value === option}>
      {option}
    </option>
  ));

  return (
    <select
      name={column}
      className={styles.dropdown}
      value={value}
      onChange={handleSelect}
    >
      <option value="-1">All {label}</option>
      {dropdownOptions}
    </select>
  );
}
